@for (linked_record of linked_recordsList; track linked_record) {
<div class="app__internal--links app__role--players--card mt-3 p-5">
  @if (!linked_record.is_running) {
  <edit-add-linked-template-popup
    [inlinedata]="processData(linked_record)"
    [inlineComponent]="true"
    [isFromLinkedTemplate]="true"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    [hideCheckbox]="isRemoveEditSaveSharing ? true : false"
    (linkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
  ></edit-add-linked-template-popup>
  }
</div>
}
